"use client"

import React, { ReactNode } from "react"
import { ThemeProvider } from "styled-components"
import { baseTheme, roadheroBaseTheme } from "@jobintrans/base-ui.theme"

export function StyledComponentsProvider({
  type = "primary",
  children,
}: {
  type?: "primary" | "roadhero"
  children?: ReactNode
}) {
  let theme = baseTheme
  if (type === "roadhero") {
    theme = roadheroBaseTheme
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
